import React from 'react'
import DoItSection from './components/DoItSection'
import MainBanner from './components/MainBanner'
import CategoriesSection from './components/CategoriesSection'
import HowItAllSection from './components/HowItAllSection'
import SpecialFeaturesSection from './components/SpecialFeaturesSection'
import MapSection from './components/MapSection'

interface IPage {}

const Page: React.FC<IPage> = () => {
  return (
    <div>
      <MainBanner />
      <DoItSection />
      <CategoriesSection />
      <HowItAllSection />
      <SpecialFeaturesSection />
      <MapSection />
    </div>
  )
}

export default Page
